import { Select } from "antd";
import { useTranslation } from "react-i18next";

const { Option } = Select;

export default function FilterPanel() {
    const { t } = useTranslation();
    return (
        <div className="p-4 mb-4 bg-white dark:bg-[#11182780] rounded-lg grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4">

            <div className="flex flex-col">
                <span className="text-sm text-gray-500 dark:text-gray-400">
                    {t('products.filter_tags')}
                </span>

                <Select
                    placeholder={t('products.filter_tags')}
                    style={{ width: "100%" }}
                    className="dark:[&_.ant-select-selector]:bg-[#1f1f1f] 
               dark:[&_.ant-select-selector]:border-[#303030] 
               dark:[&_.ant-select-selector]:text-white"
                >
                    <Option value="tag1">Tag 1</Option>
                </Select>
            </div>

            <div className="flex flex-col">
                <span className="text-sm text-gray-500 dark:text-gray-400">
                    {t('products.filter_status')}
                </span>

                <Select
                    placeholder={t('products.filter_status')}
                    style={{ width: "100%" }}
                    className="dark:[&_.ant-select-selector]:bg-[#1f1f1f] 
               dark:[&_.ant-select-selector]:border-[#303030] 
               dark:[&_.ant-select-selector]:text-white"
                >
                    <Option value="active">{t('products.status_active')}</Option>
                    <Option value="inactive">{t('products.status_inactive')}</Option>
                </Select>
            </div>

            <div className="flex flex-col">
                <span className="text-sm text-gray-500 dark:text-gray-400">
                    {t('products.filter_category')}
                </span>

                <Select
                    placeholder={t('products.filter_category')}
                    style={{ width: "100%" }}
                    className="dark:[&_.ant-select-selector]:bg-[#1f1f1f] 
               dark:[&_.ant-select-selector]:border-[#303030] 
               dark:[&_.ant-select-selector]:text-white"
                >
                    <Option value="beauty">Làm đẹp</Option>
                </Select>
            </div>

            <div className="flex flex-col">
                <span className="text-sm text-gray-500 dark:text-gray-400">
                    {t('products.filter_stock')}
                </span>

                <Select
                    placeholder={t('products.filter_stock')}
                    style={{ width: "100%" }}
                    className="dark:[&_.ant-select-selector]:bg-[#1f1f1f] 
                    dark:[&_.ant-select-selector]:border-[#303030] 
                    dark:[&_.ant-select-selector]:text-white"
                >
                    <Option value="in">{t('products.stock_in')}</Option>
                    <Option value="out">{t('products.stock_out')}</Option>
                </Select>
            </div>

            <div className="ml-auto text-gray-700 dark:text-gray-300">
                <span className="text-blue-500 mr-2">•</span>
                {t('products.total_products')}
                <div className="text-lg font-semibold">0</div>
            </div>

        </div>
    );
}